<script>
  export default {
    name: 'ModalStamp'
  }
</script>

<template lang="pug">
  transition(
    name = 'modal-stamp'
    )
    .modal-stamp(
      v-if = '$store.state.isShownModalStamp === true'
      )
      img.modal-stamp__img(
        src = '~@/assets/img/modal_stamp.png'
        )
      .modal-stamp__bg
</template>

<style lang="scss">
  .modal-stamp {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    transform: translate3d(0, 0, 0);
    &__img {
      display: block;
      position: absolute;
      z-index: 10;
      @include l-more-than-mobile {
        width: 300px;
        height: 300px;
        top: calc(50% - 150px);
        left: calc(50% - 150px);
      }
      @include l-mobile {
        width: 250px;
        height: 250px;
        top: calc(50% - 125px);
        left: calc(50% - 125px);
      }
    }
    &__bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.7);
    }

    //
    // 表示・非表示アニメーション
    &.modal-stamp-enter-to {
      transition-duration: 0.87s;
    }
    &.modal-stamp-leave-to {
      transition-duration: 0.4s;
    }

    &__img {
      .modal-stamp-enter & {
        opacity: 0;
        transform: scale(0.15);
      }
      .modal-stamp-enter-to & {
        opacity: 1;
        transform: scale(1);
        transition-duration: 0.4s;
        transition-delay: 0.47s;
        transition-property: opacity, transform;
        transition-timing-function: cubic-bezier(.41,2.0,.54,.93);
      }
      .modal-stamp-leave-to & {
        opacity: 0;
        transform: scale(0.15);
        transition-duration: 0.2s;
        transition-property: opacity, transform;
      }
    }

    &__bg {
      .modal-stamp-enter & {
        opacity: 0;
      }
      .modal-stamp-enter-to & {
        opacity: 1;
        transition-duration: 0.3s;
        transition-property: opacity;
      }
      .modal-stamp-leave-to & {
        opacity: 0;
        transition-duration: 0.2s;
        transition-delay: 0.2s;
        transition-property: opacity;
      }
    }
  }
</style>
